module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('em', [_vm._v("He Defended His Hometown")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECOND")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEUTENANT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CENERY")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R. WAS AN ANOM")]), _vm._v("aly in the Twelfth Virginia Infantry. He was a factory manager in Petersburg before the war, and men of his occupation rarely became officers. The class-conscious men in the regiment frowned upon the workers he supervised in civilian life as belonging to “a distinct and definitely lower social class,” according to a regimental historian."), _c('a', {
    attrs: {
      "id": "ren11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McEnery, the eldest of four children raised by Peter Sr., an immigrant from Limerick, Ireland, and his Virginia-born wife, Dorothy, grew up in Petersburg."), _c('a', {
    attrs: {
      "id": "ren12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" The elder McEnery prospered as a slaveholding tobacco merchant with clients in the North and Great Britain. He conducted his business from a large factory, and Peter Jr. ran its daily operations. The young man also served as a first sergeant in the Petersburg City Guard, a militia company noted for being part of the security detail present at the hanging of John Brown in 1859."), _c('a', {
    attrs: {
      "id": "ren13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon after the start of the war, McEnery’s militia company elected him second lieutenant and merged into the Confederate army as part of the Twelfth Virginia Infantry. One year later, in May 1862, the company’s term of enlistment expired. It reorganized and held elections for officers. Two documents in his military service file record the result: One notes that the rank and file failed to reelect him, and another states that he was “thrown out” of the regiment. The reason why is unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McEnery reentered the military in 1864 as a private in Capt. Edward Graham’s Virginia Horse Artillery. Its best-known action occurred in defense of Petersburg on June 9, 1864: Graham’s gunners, part of a hastily organized force of about 2,500 men, drove back a superior force of Yankee invaders. In a congratulatory "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("order, the general in charge, the acerbic Henry Wise, stated, “With such troops as all have proven themselves, commanders may well give assurance with confidence to the people of Petersburg.”"), _c('a', {
    attrs: {
      "id": "ren14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" The city held out against the enemy until April 1865.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McEnery’s whereabouts after the war are sketchy. The 1880 census lists him as a Petersburg policeman, unmarried, and living in a boarding house. He was in his early forties."), _c('a', {
    attrs: {
      "id": "ren15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Pvt. Peter A. McEnery Jr., Capt. Edward Graham’s Company, Virginia Horse Artillery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Carte de visite")]), _vm._v(" by Stanton (life dates unknown) & Butler (life dates unknown) of Baltimore, Maryland, about 1865. William A. Turner collection.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5747e2e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 90
// module chunks = 0